// extracted by mini-css-extract-plugin
module.exports = {"icon":"WarningTooltip_icon_1TAzy"};